import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { User } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SurveyForm, { SurveyFormValues } from '../forms/SurveyForm'
import { RecordResponse } from '@/modules/Survey/types'

interface RecordResponseDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    customerName?: string
    initialResponses?: RecordResponse
    onSave: (responses: RecordResponse) => void
}

const RecordResponseDialog = ({
    open,
    onOpenChange,
    customerName,
    initialResponses,
    onSave,
}: RecordResponseDialogProps) => {
    const { t } = useTranslation('surveys')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleFormSubmit = async (values: SurveyFormValues) => {
        setIsSubmitting(true)
        try {
            onSave(values)
        } catch (error) {
            console.error('Error saving survey responses:', error)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-xl mb-4">
                        {t(
                            'surveys.responses.record_response',
                            'Record Response'
                        )}
                    </DialogTitle>
                    <div className="flex flex-col gap-3 p-4 bg-muted/50 rounded-lg border">
                        <div className="flex items-center gap-2">
                            <User className="h-4 w-4 text-muted-foreground" />
                            <span className="text-sm text-muted-foreground w-20">
                                {t(
                                    'surveys.responses.customer_label',
                                    'Customer'
                                )}
                                :
                            </span>
                            <span className="font-semibold text-base">
                                {customerName}
                            </span>
                        </div>
                    </div>
                </DialogHeader>

                <div>
                    <SurveyForm
                        initialValues={initialResponses}
                        onSubmit={handleFormSubmit}
                        onCancel={() => onOpenChange(false)}
                        isSubmitting={isSubmitting}
                        submitLabel={t('confirm', 'Confirm')}
                        showActions={true}
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default RecordResponseDialog
